export default __webpack_public_path__ + "static/media/exchange-light-mode.37eadb6f.svg";